import { Component, computed, inject, input, signal } from '@angular/core';
import { FormatNumberPipe, signalHelpers } from '@core';
import { DeviceDatapoint } from '@devices';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { type WidgetDataPoint } from '../../../models';
import { DashboardStore, getChartKey } from '../../../stores';

@Component({
  imports: [
    FormatNumberPipe,
    NgxSkeletonLoaderModule,
  ],
  selector: 'avs-data-point',
  styleUrl: './data-point.component.scss',
  templateUrl: './data-point.component.html',
})
export class DataPointComponent {
  config = input.required<WidgetDataPoint>();

  protected datapoint = computed(() => {
    const chartData = this.chartState();
    const datapoint = chartData?.timeseries.at(-1);

    if (!chartData || !datapoint) {
      return {
        date: '',
        value: null,
      };
    }

    return {
      date: new Date(datapoint.timeStamp).toLocaleString('en-US'),
      unit: chartData.name as DeviceDatapoint !== DeviceDatapoint.CONNECTED
        ? chartData.measurementUnit
        : null,
      value: datapoint.value,
    };
  });
  protected datapointName = computed(() => {
    const attr = this.deviceState()?.additionalAttributes?.find(
      a => a.name === this.config().datapointName,
    );

    return attr?.friendlyName || attr?.name;
  });
  protected isLoading = computed(() => !this.chartState() || !this.deviceState());

  private store = inject(DashboardStore);
  private chartKey = computed(() => getChartKey(this.config().deviceId, this.config().datapointName));
  private deviceKey = signal('');
  private chartState = computed(() => this.store.chartData(this.chartKey())());
  private deviceState = computed(() => this.store.deviceDetails(this.deviceKey())());

  constructor() {
    signalHelpers.untrackedEffect([this.config], (config) => {
      this.store.loadChartData(config.deviceId, { latestOnly: true, point: config.datapointName });
      this.deviceKey.set(this.store.loadDeviceDetails(config.deviceId));
    });
  }
}
